import { Box, Button, Container, Typography } from "@mui/material";
import blogs from "../data/blogs";
import { useNavigate, useParams } from "react-router-dom";

export default function BlogDetail() {
  const { id } = useParams();
  const blog = blogs.find((b) => b.id === Number(id));
  const navigate = useNavigate();

  if (!blog) return <Typography variant="h5">Blog not found!</Typography>;

  return (
    <Container maxWidth="md">
      <Box sx={{ textAlign: "center", my: 4 }}>
        <Typography variant="h3" fontWeight="bold" color="primary">
          {blog.title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
          {blog.date}
        </Typography>
      </Box>
      <img
        src={blog.image}
        alt={blog.title}
        style={{ width: "100%", borderRadius: "10px" }}
      />
      <Typography variant="body1" sx={{ mt: 3, fontSize: "1.2rem" }}>
        {blog.content}
      </Typography>

      {/* Back Button */}
      <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
        Back
      </Button>
    </Container>
  );
}
